import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  einstellungen: [],
  loading: false,
  error: null
}

// getters
const getters = {
  einstellungen (state) {
    return state.einstellungen
  },
  einstellung: (state) => (value) => {
    switch (value) {
      case 'kalender':
        let kalender = state.einstellungen.find(einstellung => einstellung.id === 'kalender')
        if (kalender) {
          kalender = Object.values(kalender)
          kalender = kalender.filter(kal => kal.isPublic === true)
        }
        return kalender

      case 'alleKalender':
        // eslint-disable-next-line
        const { id, ...kalenderOhneId } = state.einstellungen.find(einstellung => einstellung.id === 'kalender')
        return Object.values(kalenderOhneId)

      default:
        return state.einstellungen.find(einstellung => einstellung.id === value)
    }
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadEinstellungen ({commit}) {
    commit('setLoading', true)
    console.log('Einstellungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen')
    .onSnapshot(snapshot => {
      const einstellungen = []
      snapshot.forEach(doc => {
        einstellungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedEinstellungen', einstellungen)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createEinstellung ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteEinstellungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteEinstellung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateEinstellungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen').doc(payload.id).update(payload)
    .then(() => {
      commit('setLoading', false)
      commit('updateEinstellung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedEinstellungen (state, payload) {
    state.einstellungen = payload
  },
  createEinstellung (state, payload) {
    state.einstellungen.push(payload)
  },
  updateEinstellung (state, payload) {
    const einstellung = state.einstellungen.find(einstellung => {
      return einstellung.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        einstellung[key] = payload[key]
      }
    })
  },
  deleteEinstellung (state, payload) {
    let array = state.einstellungen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.einstellungen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/einstellungen_alt.js